import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * Admin client for account-scoped notes, attachments and audit history.
 * Backed by the owner-keyed content endpoints (ownerType=ACCOUNT).
 */
@Injectable({ providedIn: 'root' })
export class AccountContentService {
  private baseUrl = `${environment.apiUrl}/api/admin/accounts`;

  constructor(private http: HttpClient) {}

  // Notes
  getNotes(accountId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/${accountId}/notes`);
  }

  addNote(accountId: number, content: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/${accountId}/notes`, { content });
  }

  // Attachments
  getAttachments(accountId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/${accountId}/attachments`);
  }

  uploadAttachment(accountId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(`${this.baseUrl}/${accountId}/attachments`, formData);
  }

  downloadAttachment(accountId: number, attachmentId: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${accountId}/attachments/${attachmentId}/download`, { responseType: 'blob' });
  }

  deleteAttachment(accountId: number, attachmentId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${accountId}/attachments/${attachmentId}`);
  }

  // History
  getHistory(accountId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/${accountId}/history`);
  }
}
